module.exports = __webpack_public_path__ + "static/img/city1.16a56a5.png";


//////////////////
// WEBPACK FOOTER
// ./public/citybrianImg/city1.png
// module id = EvC2
// module chunks = 0